// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"661":"4777577a","709":"d84ce64f"}[chunkId] + ".css";
};